import { Box, Heading, Switch, Text, VStack } from "@chakra-ui/react";
import { useLocalStorage } from "usehooks-ts";
import { updateBaseURL } from "../../api/api";
import { updateBaseURL as updateBaseURLOSS } from "../../api/apiOSS";
import { Actions, Analytics, Features } from "../shared/analytics";
import { capture } from "../../shared/capture";
import { isStagingEnv } from "../../shared/util";
import useMetriportToast from "../shared/toast";

export default function SandboxToggle() {
  const toast = useMetriportToast();
  const [isSandbox, setIsSandbox] = useLocalStorage<boolean>("isSandbox", false);

  function onSandboxToggle() {
    // keep using a local variable below since the state might not be updated yet when the code
    // after `setIsSandbox` runs
    const newIsSandbox = !isSandbox;
    setIsSandbox(newIsSandbox);
    Analytics.emit(Actions.toggle, Features.sandbox, {
      isOn: newIsSandbox,
    });
    updateBaseURL(newIsSandbox);
    updateBaseURLOSS(newIsSandbox);
    capture.updateSandboxEnvironment(newIsSandbox);
    if (isStagingEnv() && newIsSandbox) {
      toast.info({
        title: "Heads up! You've enabled the sandbox mode in staging. Key generation is disabled.",
        duration: 5000,
      });
    }
  }

  return (
    <Box>
      <VStack align="left">
        <Heading>Sandbox</Heading>
        <Text>
          Toggle the sandbox mode on/off to access your Sandbox-specific API key & settings. This is
          a website-wide action, all features in the dashboard are impacted by this change.
        </Text>
        <Switch id="sandbox-mode" size="lg" onChange={onSandboxToggle} isChecked={isSandbox} />
      </VStack>
    </Box>
  );
}
